import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      display: block;\n      margin: 0;\n      color: ", ";\n\n      ", "\n\n      ", "\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { N200, N900 } from '@atlaskit/theme/colors';

var Text = function Text(_ref) {
  var secondary = _ref.secondary,
      children = _ref.children,
      truncate = _ref.truncate;
  return jsx("span", {
    css: css(_templateObject(), N900, truncate && "\n        overflow-x: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      ", secondary && "\n          color: ".concat(N200, ";\n          font-size: 0.85em;\n      "))
  }, children);
};

export default Text;